import React from 'react';
import {FlexContainer} from 'app/styles/content';
import styled from 'styled-components';
import {COLORS, SIZES} from '@fupa/fupa-uikit';

const Container = styled(FlexContainer)`
  justify-content: center;
  background-color: ${COLORS.lighterGrey};

  div:first-child {
    min-width: 7.5rem;
    padding: 0 ${SIZES['16']};
  }
`;

const TileContainer = ({children}) => {
  return <Container>{children}</Container>;
};

export default TileContainer;
